module.exports = __webpack_public_path__ + "img/logo.35ab68c6.jpg";